import { ImageAdd20Regular } from "@fluentui/react-icons";
import { MenuButton, useRichTextEditorContext } from "mui-tiptap";
import { useState } from "react";
import ImagePickerDialog from "../image/ImagePickerDialog";
import { Image } from "../../models/Image";

type MenuButtonImagePickerProps = {
  tooltipLabel: string;
  ariaLabel: string;
};

export default function MenuButtonImagePicker({
  tooltipLabel,
  ariaLabel,
}: MenuButtonImagePickerProps) {
  const editor = useRichTextEditorContext();
  const [open, setOpen] = useState(false);

  const handleSelect = (image: Image) => {
    if (editor) {
      editor
        .chain()
        .focus()
        .insertContent({
          type: "image",
          attrs: {
            src: image.webUrl,
            style: "width: 100%; height: 100%;",
            "data-image-id": image.imageId,
            "data-version-id": image.versionId,
            title: image.title,
          },
        })
        .run();
    }
  };

  return (
    <>
      <MenuButton
        IconComponent={({ className }) => (
          <ImageAdd20Regular className={className} />
        )}
        onClick={() => setOpen(true)}
        tooltipLabel={tooltipLabel}
        aria-label={ariaLabel}
      />
      <ImagePickerDialog
        externalOpen={open}
        onOpenChange={setOpen}
        onSelect={handleSelect}
      />
    </>
  );
}
